import { React, useState, useEffect } from "react";
import {
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Card,
  CardContent,
  CardHeader,
  InputAdornment,
  Link,
} from "@mui/material";
import { Link as RouterLink, useNavigate, useParams, useLocation } from "react-router-dom";
import { getJobOrder } from "../API/jobOrderAPI";
import { getClient } from "../API/clientAPI";

import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import BaseFormWrapper from "../../components/shared/BaseFormWrapper";


function ViewServiceReport() {
  const { id } = useParams();
  const [jobOrder, setJobOrder] = useState({});
  const [client, setClient] = useState({});
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const returnTo = searchParams.get('returnTo');

  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchJobOrder = async () => {
      try {
        setIsLoading(true);
        const data = await getJobOrder(id);
        const client = await getClient(data.client_id); // Fetch client using client_id from job order
        setClient(client);
        console.log(data);
        setJobOrder(data);
      } catch (err) {
        setErrorMessage("Error fetching job order:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchJobOrder(); // Fetch the job order if the ID exists
  }, []); // Dependency array ensures the effect runs when ID changes

  const competencies = [
    "General Pest Control",
    "Termite Control",
    "QPMS",
    "Disinfection",
    "Basic Safety",
    "Driving 2 Wheels",
    "Driving 4 Wheels",
  ];
  const specializationGPC = [
    "Rodent",
    "Baiting",
    "Cockroach",
    "Fly Control",
    "Ant Control",
    "Larviciding",
  ];

  const specializationTermite = [
    "Compre",
    "AG",
    "IG",
    "IC",
    "Spraying",
    "Soil Poisoning",
  ];

  const job_types = [
    "GPC",
    "Fogging",
    "Monitoring",
    "Deep Cleaning",
    "QTM",
    "Heat Treatment",
    "Vacuuming",
    "Termite Control",
    "Comprehensive Termite",
    "Termite Baiting",
    "Termite Spot Spraying",
    "AG Installation",
    "Phase 1 and Phase 2",
    "QPMS",
    "Ant Control",
    "Cockroach Control",
    "Mosquito Control",
    "Cockroach Gel Bait/Powder",
    "Basic Rodent Control",
    "Intensive Rodent Control",
    "Termite Inspection",
    "Disinfection",
    "Billing",
    "Collection",
    "Deliver Service Invoice",
    "Deliver Certificate",
    "QuickCert",
    "Ocular",
    "Rodent Monitoring",
    "Daily Monitoring",
    "Logistics",
    "ILT Monitoring",
    "Facility Audit",
    "Meeting/Seminar",
    "QA Visit",
    "Termipore Installation",
    "In2Care Installation",
    "Exterra Inground",
    "Delivery of Materials",
    "Backjob"
  ]

  const legendTable = [
    {
      finding: "1 Presence of foul odor",
      recommendation: "A Keep areas clean and dry",
    },
    {
      finding: "2 Trash bins left uncovered",
      recommendation: "B Keep trash bins covered",
    },
    {
      finding: "3 Dirt/Organic Matter Present",
      recommendation: "C Dispose Garbage Daily",
    },
    {
      finding: "4 Cracks and Crevices",
      recommendation: "D Seal / Caulking of Cracks and Crevices",
    },
    {
      finding: "5 Pest Entry Point / Open Windows",
      recommendation: "E Keep doors/windows closed",
    },
    {
      finding: "6 Stagnant Water / Leaking Pipes",
      recommendation: "F Fix leaking pipes and gutters",
    },
    {
      finding: "7 Build-up of Old Stocks",
      recommendation: "G Organize Piling and Storage",
    },
    {
      finding: "8 Closed Room or Area Inaccessible",
      recommendation: "H Make room available for inspection",
    },
    {
      finding: "9 Active termites found",
      recommendation: "I Install screens/weather strip",
    },
  ];

  const inspectionPestColumns = [
    "Roaches",
    "Mosq",
    "Rodents",
    "Flies",
    "Ants",
    "Others",
  ];
  const inspectionRows = Array.from({ length: 10 }, (_, index) => ({
    id: index + 1,
  })); // Example rows

  return (
    <BaseFormWrapper
      titleIcon={<ReceiptLongIcon />}
      title="Operations"
      subTitle="Service Reports"
      subTitleRoute="/manage-service-reports"
      formTitle="View Service Report"
      errorMessage={errorMessage}
      setErrorMessage={setErrorMessage}
      isLoading={isLoading}
    >
      <Grid container>
        <Grid
          item
          xs={12}
          md={12}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Card
            variant="outlined"
            sx={{ padding: "20px", marginBottom: "20px", flex: 1 }}
          >
            <CardHeader
              title={
                <Typography
                  variant="h6"
                  sx={{
                    paddingBottom: "1rem",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: "1rem",
                  }}
                >
                  Basic Information
                </Typography>
              }
            />
            <CardContent
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              {" "}
              <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={2}>
                  <TextField
                    name="id"
                    label="Job Order ID"
                    value={jobOrder?.id || ""}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={2}>
                  <FormControl fullWidth>
                    <InputLabel id="job-order-status-label">
                      Job Order Status
                    </InputLabel>
                    <Select
                      labelId="job-order-status-label"
                      name="status"
                      value={jobOrder?.status || ""}
                      label="Job Order Status"
                      disabled
                    >
                      <MenuItem value="Not Done">Not Done</MenuItem>
                      <MenuItem value="Rescheduled">Rescheduled</MenuItem>
                      <MenuItem value="Done">Done</MenuItem>
                      <MenuItem value="Cancelled By Client">
                        Cancelled By Client
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    name="Client ID"
                    label="Client ID"
                    value={jobOrder?.client_id || ""}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    name="Client Name"
                    label="Client Name"
                    value={jobOrder?.client?.name || ""}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12} lg={10}>
                      <TextField
                        label="Job Site Address"
                        variant="outlined"
                        fullWidth
                        value={
                          jobOrder?.client?.address
                            ? `${jobOrder.client.address.house_unit_street || ""
                            }, ${jobOrder.client.address.barangay || ""
                            }, ${jobOrder.client.address.city || ""
                            }, ${jobOrder?.client?.address.metro_province || ""} ${jobOrder.client.address.zipcode || ""}`
                            : ""
                        }
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} md={12} lg={2}>
                      <TextField
                        name="area"
                        label="Area"
                        value={jobOrder?.client?.address?.area || ""}
                        fullWidth
                        disabled
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={12} lg={4}>
                  <TextField
                    fullWidth
                    label="Contact Person"
                    variant="outlined"
                    value={
                      jobOrder.client?.contact
                        ? `${jobOrder.client.contact.lastname || ""}, ${jobOrder.client.contact.firstname || ""
                        }`
                        : ""
                    } // Display the contact's full name or an empty string if not available
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={4}>
                  <TextField
                    fullWidth
                    label="Contact Email"
                    variant="outlined"
                    value={jobOrder.client?.contact?.email?.email || ""} // Display the contact email or an empty string if not available
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={4}>
                  <TextField
                    fullWidth
                    label="Contact Number"
                    variant="outlined"
                    value={
                      jobOrder.client?.contact?.number
                        ? `${jobOrder.client.contact.number.type}: ${jobOrder.client.contact.number.number}`
                        : ""
                    } // Display the contact number or an empty string if not available
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={4}>
                  <TextField
                    fullWidth
                    label="Category"
                    variant="outlined"
                    value={client?.category || ""}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} md={12} lg={4}>
                  <TextField
                    fullWidth
                    label="Parent Client"
                    variant="outlined"
                    value={client?.parent_client?.name || ""}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={4}>
                  <TextField
                    label="Location Type"
                    value={
                      client?.location_type
                        ? client.location_type
                        : ""
                    }
                    fullWidth
                    variant="outlined"
                    sx={{ fontSize: "0.875rem" }}
                    disabled
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* <Grid item xs={12}>
          <Card
            variant="outlined"
            sx={{ padding: "20px", marginBottom: "20px" }}
          >
            <CardHeader
              title={
                <Typography
                  variant="h6"
                  sx={{
                    paddingBottom: "1rem",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: "1rem",
                  }}
                >
                  Job Type
                </Typography>
              }
            />
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Job Type"
                      variant="outlined"
                      value={
                        jobOrder?.job_type
                          ? jobOrder.job_type.charAt(0).toUpperCase() +
                          jobOrder.job_type.slice(1)
                          : ""
                      }
                      disabled
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid> */}

        <Grid item xs={12}>
          <Card
            variant="outlined"
            style={{ overflowX: 'auto' }}
          >
            <CardHeader
              title={
                <Typography
                >
                  Job Type
                </Typography>
              }
              sx={{
                padding: 0
              }}
            />
            <CardContent
              sx={{
                padding: "0 !important",
                display: "grid",
                gridTemplateColumns: "repeat(7, auto)",
                gap: 1,
              }}
            >
              {job_types.map((option) => {
                const formattedOption = option
                  .toLowerCase()
                  .replace(/\s+/g, "_");
                return (
                  <FormControlLabel
                    key={formattedOption}
                    control={
                      <Checkbox
                        name={formattedOption}
                        checked={(jobOrder.job_types || []).includes(formattedOption)}
                        disabled
                      />
                    }
                    label={option}
                  />

                );
              })}
            </CardContent>
          </Card>
        </Grid>

        <Grid
          item
          xs={12}
          md={12}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Card
            variant="outlined"
            sx={{ padding: "20px", marginBottom: "20px", flex: 1 }}
          >
            <CardHeader
              title={
                <Typography
                  variant="h6"
                  sx={{
                    paddingBottom: "1rem",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: "1rem",
                  }}
                >
                  Competency
                </Typography>
              }
            />

            <CardContent
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 2,
                    flexWrap: "wrap",
                  }}
                >
                  {competencies.map((option) => {
                    const formattedOption = option
                      .toLowerCase()
                      .replace(/\s+/g, "_");
                    return (
                      <FormControlLabel
                        key={formattedOption}
                        control={
                          <Checkbox
                            name={formattedOption}
                            checked={
                              jobOrder?.competencies?.includes(
                                formattedOption
                              ) || false
                            }
                            disabled
                          />
                        }
                        label={option}
                      />
                    );
                  })}
                </Box>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid
          item
          xs={6}
          md={6}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Card
            variant="outlined"
            sx={{ padding: "20px", marginBottom: "20px", flex: 1 }}
          >
            <CardHeader
              title={
                <Typography
                  variant="h6"
                  sx={{
                    paddingBottom: "1rem",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: "1rem",
                  }}
                >
                  Specialization - General Pest Control
                </Typography>
              }
            />

            <CardContent
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 2,
                    flexWrap: "wrap",
                  }}
                >
                  {specializationGPC.map((option) => {
                    const formattedOption = option
                      .toLowerCase()
                      .replace(/\s+/g, "_");
                    return (
                      <FormControlLabel
                        key={formattedOption}
                        control={
                          <Checkbox
                            name={formattedOption}
                            checked={
                              jobOrder?.specialization?.general_pest_control?.includes(
                                formattedOption
                              ) || false
                            }
                            disabled
                          />
                        }
                        label={option}
                      />
                    );
                  })}
                </Box>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid
          item
          xs={6}
          md={6}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Card
            variant="outlined"
            sx={{ padding: "20px", marginBottom: "20px", flex: 1 }}
          >
            <CardHeader
              title={
                <Typography
                  variant="h6"
                  sx={{
                    paddingBottom: "1rem",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: "1rem",
                  }}
                >
                  Specialization - Termite
                </Typography>
              }
            />

            <CardContent
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 2,
                    flexWrap: "wrap",
                  }}
                >
                  {specializationTermite.map((option) => {
                    const formattedOption = option
                      .toLowerCase()
                      .replace(/\s+/g, "_");
                    return (
                      <FormControlLabel
                        key={formattedOption}
                        control={
                          <Checkbox
                            name={formattedOption}
                            checked={
                              jobOrder?.specialization?.termite?.includes(
                                formattedOption
                              ) || false
                            }
                            disabled
                          />
                        }
                        label={option}
                      />
                    );
                  })}
                </Box>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Card
            variant="outlined"
            sx={{ padding: "20px", marginBottom: "20px", flex: 1 }}
          >
            <CardHeader
              title={
                <Typography
                  variant="h6"
                  sx={{
                    paddingBottom: "1rem",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: "1rem",
                  }}
                >
                  Special Notes
                </Typography>
              }
            />
            <CardContent sx={{ flex: 1 }}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    label="Special Notes"
                    name="special_notes"
                    type="text"
                    value={jobOrder.special_notes || ""}
                    fullWidth
                    disabled
                    multiline
                    rows={4}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Card
            variant="outlined"
            sx={{ padding: "20px", marginBottom: "20px", flex: 1 }}
          >
            <CardHeader
              title={
                <Typography
                  variant="h6"
                  sx={{
                    paddingBottom: "1rem",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: "1rem",
                  }}
                >
                  Appointment
                </Typography>
              }
            />
            <CardContent sx={{ flex: 1 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={6}>
                  <FormControl fullWidth>
                    <InputLabel id="appointment-type-label">
                      Appointment Type
                    </InputLabel>
                    <Select
                      labelId="appointment-type-label"
                      name="appointment_type"
                      value={jobOrder?.appointment_type || ""}
                      label="appointment_type"
                      disabled
                    >
                      <MenuItem value="Initial">Initial</MenuItem>
                      <MenuItem value="Follow-up">Follow-up</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <FormControl fullWidth>
                    <InputLabel id="treatment-type-label">
                      Treatment Type
                    </InputLabel>
                    <Select
                      labelId="treatment-type-label"
                      name="treatment_type"
                      value={jobOrder?.treatment_type || ""}
                      label="treatment_type"
                      disabled
                    >
                      <MenuItem value="QB">QB</MenuItem>
                      <MenuItem value="FFUP">FFUP</MenuItem>
                      <MenuItem value="LT">LT</MenuItem>
                      <MenuItem value="QBLT">QBLT</MenuItem>
                      <MenuItem value="Backjob">Backjob</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Card
            variant="outlined"
            sx={{ padding: "20px", marginBottom: "20px", flex: 1 }}
          >
            <CardContent sx={{ flex: 1 }}>
              <Grid item xs={12}>
                <TableContainer sx={{ overflowX: "auto" }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={8}
                          sx={{ fontWeight: "bold" }}
                        >
                          Inspection and Pest Count
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Findings
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Recommendation
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          align="center"
                          rowSpan={2}
                          sx={{ fontWeight: "bold" }}
                        >
                          Location
                        </TableCell>
                        <TableCell
                          align="center"
                          colSpan={inspectionPestColumns.length}
                          sx={{ fontWeight: "bold" }}
                        >
                          Pests
                        </TableCell>
                        <TableCell
                          align="center"
                          rowSpan={2}
                          sx={{ fontWeight: "bold" }}
                        >
                          Total
                        </TableCell>
                        <TableCell align="center" rowSpan={2}>
                          (Pls write possible root cause or Refer to Legend
                          below)
                        </TableCell>
                        <TableCell align="center" rowSpan={2}>
                          (Pls write client's action or Pls refer to Legend
                          below)
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        {inspectionPestColumns.map((pest, index) => (
                          <TableCell
                            key={index}
                            align="center"
                            sx={{ fontWeight: "bold" }}
                          >
                            {pest}
                          </TableCell>
                        ))}
                        <TableCell sx={{ fontWeight: "bold" }} />
                        <TableCell sx={{ fontWeight: "bold" }} />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {jobOrder?.inspection_report?.map((report, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              value={report?.location || ""}
                              disabled
                              sx={{ minWidth: 150 }}
                            />
                          </TableCell>

                          {[
                            "Roaches",
                            "Mosq",
                            "Rodents",
                            "Flies",
                            "Ants",
                            "Others",
                          ].map((pestType, colIndex) => (
                            <TableCell key={colIndex}>
                              <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                value={report?.pests?.[pestType] || "0"}
                                disabled
                                sx={{ minWidth: 50 }}
                              />
                            </TableCell>
                          ))}

                          <TableCell>
                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              value={Object.values(report?.pests || {}).reduce(
                                (sum, value) =>
                                  sum + (parseInt(value, 10) || 0),
                                0
                              )}
                              disabled
                              sx={{ minWidth: 50 }}
                            />
                          </TableCell>

                          <TableCell>
                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              value={report?.findings || ""}
                              disabled
                              sx={{ minWidth: 150 }}
                            />
                          </TableCell>

                          <TableCell>
                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              value={report?.recommendation || ""}
                              disabled
                              sx={{ minWidth: 150 }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}

                      <TableRow>
                        <TableCell style={{ fontWeight: "bold" }}>
                          Overall Total Pests
                        </TableCell>

                        {[
                          "Roaches",
                          "Mosq",
                          "Rodents",
                          "Flies",
                          "Ants",
                          "Others",
                        ].map((pestType, colIndex) => (
                          <TableCell key={colIndex}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              value={
                                jobOrder?.inspection_report?.reduce(
                                  (sum, report) =>
                                    sum +
                                    (parseInt(report?.pests?.[pestType], 10) ||
                                      0),
                                  0
                                ) || 0
                              }
                              disabled
                              sx={{ minWidth: 50 }}
                            />
                          </TableCell>
                        ))}

                        <TableCell>
                          <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            value={
                              jobOrder?.inspection_report?.reduce(
                                (grandTotal, report) => {
                                  return (
                                    grandTotal +
                                    Object.values(report?.pests || {}).reduce(
                                      (sum, value) =>
                                        sum + (parseInt(value, 10) || 0),
                                      0
                                    )
                                  );
                                },
                                0
                              ) || 0
                            }
                            disabled
                            sx={{ minWidth: 50 }}
                          />
                        </TableCell>

                        <TableCell colSpan={2}></TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Card
            variant="outlined"
            sx={{ padding: "20px", marginBottom: "20px", flex: 1 }}
          >
            <CardContent sx={{ flex: 1 }}>
              <Grid item xs={12}>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={2}
                          style={{ fontWeight: "bold" }}
                        >
                          Legend / Code
                        </TableCell>
                        <TableCell
                          align="center"
                          colSpan={2}
                          style={{ fontWeight: "bold" }}
                        >
                          Activities Done
                        </TableCell>
                        <TableCell
                          align="center"
                          colSpan={2}
                          style={{ fontWeight: "bold" }}
                        >
                          Services Performed
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell style={{ fontWeight: "bold" }}>
                          Findings
                        </TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>
                          Recommendations
                        </TableCell>
                        <TableCell align="center" colSpan={4}>
                          (Please check beside)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {jobOrder?.services?.length > 0 ? (
                        jobOrder.services.map((service, index) => (
                          <TableRow key={service?.id || index}>
                            <TableCell>
                              {legendTable?.[index]?.finding || ""}
                            </TableCell>
                            <TableCell>
                              {legendTable?.[index]?.recommendation || ""}
                            </TableCell>
                            <TableCell>{service?.activity || ""}</TableCell>
                            <TableCell>
                              <Checkbox
                                checked={service?.activityChecked || false}
                                disabled
                              />
                            </TableCell>
                            <TableCell>{service?.service || ""}</TableCell>
                            <TableCell>
                              <Checkbox
                                checked={service?.serviceChecked || false}
                                disabled
                              />
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={6} align="center">
                            No Services Available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid
          item
          xs={12}
          md={12}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Card
            variant="outlined"
            sx={{ padding: "20px", marginBottom: "20px", flex: 1 }}
          >
            <CardContent sx={{ flex: 1 }}>
              <Grid item xs={12}>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={2}
                          style={{ fontWeight: "bold" }}
                        >
                          Chemical Used / Batch # / Expiration
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold" }}
                        >
                          Dilution
                        </TableCell>
                        <TableCell
                          align="center"
                          colSpan={2}
                          style={{ fontWeight: "bold" }}
                        >
                          Equipment Used
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold" }}
                        >
                          Reminder Notes
                        </TableCell>
                        <TableCell
                          align="center"
                          colSpan={4}
                          style={{ fontWeight: "bold" }}
                        >
                          Service Fee
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {jobOrder?.chemical_used?.map((chemical, index) => (
                        <TableRow key={index}>
                          <TableCell>{chemical?.label || ""}:</TableCell>
                          <TableCell>
                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              value={chemical?.chemical || ""}
                              disabled
                              sx={{ minWidth: 100 }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              value={chemical?.dilution || ""}
                              disabled
                              sx={{ minWidth: 50 }}
                            />
                          </TableCell>

                          {index < (jobOrder?.equipment_used?.length || 0) ? (
                            <>
                              <TableCell>
                                {jobOrder?.equipment_used?.[index]?.label || ""}
                              </TableCell>
                              <TableCell>
                                <Checkbox
                                  checked={
                                    jobOrder?.equipment_used?.[index]?.usage ||
                                    false
                                  }
                                  disabled
                                />
                              </TableCell>
                            </>
                          ) : (
                            <>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                            </>
                          )}

                          {index === 0 && (
                            <TableCell rowSpan={6}>
                              <TextField
                                fullWidth
                                variant="outlined"
                                value={jobOrder?.reminder_notes || ""}
                                multiline
                                rows={16}
                                disabled
                                sx={{ minWidth: 150 }}
                              />
                            </TableCell>
                          )}

                          {index === 0 && (
                            <TableCell rowSpan={2} colSpan={4}>
                              <TextField
                                variant="outlined"
                                value={jobOrder?.service_fee || ""}
                                disabled
                                size="small"
                                fullWidth
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      ₱
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </TableCell>
                          )}

                          {index === 2 && (
                            <TableCell align="center" colSpan={4}>
                              Payment Status:
                            </TableCell>
                          )}

                          {index === 3 && (
                            <>
                              <TableCell>
                                {jobOrder?.service_report_payment_status?.[0]?.label || ""}
                              </TableCell>
                              <TableCell>
                                <Checkbox
                                  checked={
                                    jobOrder?.service_report_payment_status?.[0]?.selection ||
                                    false
                                  }
                                  disabled
                                />
                              </TableCell>
                              <TableCell>
                                {jobOrder?.service_report_payment_method?.[0]?.label || ""}
                              </TableCell>
                              <TableCell>
                                <Checkbox
                                  checked={
                                    jobOrder?.service_report_payment_method?.[0]?.selection ||
                                    false
                                  }
                                  disabled
                                />
                              </TableCell>
                            </>
                          )}

                          {index === 4 && (
                            <>
                              <TableCell>
                                {jobOrder?.service_report_payment_status?.[1]?.label || ""}
                              </TableCell>
                              <TableCell>
                                <Checkbox
                                  checked={
                                    jobOrder?.service_report_payment_status?.[1]?.selection ||
                                    false
                                  }
                                  disabled
                                />
                              </TableCell>
                              <TableCell>
                                {jobOrder?.service_report_payment_method?.[1]?.label || ""}
                              </TableCell>
                              <TableCell>
                                <Checkbox
                                  checked={
                                    jobOrder?.service_report_payment_method?.[1]?.selection ||
                                    false
                                  }
                                  disabled
                                />
                              </TableCell>
                            </>
                          )}

                          {index === 5 && (
                            <>
                              <TableCell>
                                {jobOrder?.service_report_payment_status?.[2]?.label || ""}
                              </TableCell>
                              <TableCell>
                                <Checkbox
                                  checked={
                                    jobOrder?.service_report_payment_status?.[2]?.selection ||
                                    false
                                  }
                                  disabled
                                />
                              </TableCell>
                              <TableCell>
                                {jobOrder?.service_report_payment_method?.[2]?.label || ""}
                              </TableCell>
                              <TableCell>
                                <Checkbox
                                  checked={
                                    jobOrder?.service_report_payment_method?.[2]?.selection ||
                                    false
                                  }
                                  disabled
                                />
                              </TableCell>
                            </>
                          )}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid
          item
          xs={12}
          md={12}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Card
            variant="outlined"
            sx={{ padding: "20px", marginBottom: "20px", flex: 1 }}
          >
            <CardHeader
              title={
                <Typography
                  variant="h6"
                  sx={{
                    paddingBottom: "1rem",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: "1rem",
                  }}
                >
                  Schedule
                </Typography>
              }
            />
            <CardContent sx={{ flex: 1 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="Start Date"
                    name="job_date"
                    type="date"
                    value={jobOrder?.job_date || ""}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="Start Time"
                    name="start_time"
                    type="time"
                    value={jobOrder?.start_time || ""}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="End Time"
                    name="end_time"
                    type="time"
                    value={jobOrder?.end_time || ""}
                    fullWidth
                    disabled
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid
          item
          xs={12}
          md={12}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Card
            variant="outlined"
            sx={{ padding: "20px", marginBottom: "20px", flex: 1 }}
          >
            <CardHeader
              title={
                <Typography
                  variant="h6"
                  sx={{
                    paddingBottom: "1rem",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: "1rem",
                  }}
                >
                  Technicians
                </Typography>
              }
            />
            <CardContent sx={{ flex: 1 }}>
              <Grid container spacing={3}>
                {jobOrder?.technicians?.length > 0 ? (
                  jobOrder.technicians.map((technician, index) => (
                    <Grid
                      item
                      xs={12}
                      md={12}
                      lg={6}
                      key={technician?.id || index}
                    >
                      <TextField
                        label={`Technician ${index + 1}`}
                        variant="outlined"
                        fullWidth
                        value={`${technician?.firstname || ""} ${technician?.lastname || ""
                          }`}
                        disabled
                      />
                    </Grid>
                  ))
                ) : (
                  <Grid item xs={12} md={12} lg={6}>
                    <TextField
                      label="Technician"
                      variant="outlined"
                      fullWidth
                      value="No Technicians Available"
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        sx: { fontSize: "0.875rem" },
                      }}
                    />
                  </Grid>
                )}
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid container spacing={3}>

          {/* Accomplished Signature Section */}
          <Grid item xs={12} md={6}>
            <Card variant="outlined"
              sx={{ padding: "20px", marginBottom: "20px", flex: 1 }}
            >
              <CardHeader title={<Typography
                variant="h6"
                sx={{
                  paddingBottom: "1rem",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  fontSize: "1rem",
                }}
              >
                Accomplished Signature
              </Typography>
              } />
              <CardContent>
                {jobOrder.accomplishedSignature && (
                  <img
                    src={jobOrder.accomplishedSignature}
                    alt="Accomplished Signature"
                    style={{ width: "80%", height: "90px", objectFit: "contain", marginBottom: "10px" }}
                  />
                )}


                <Grid container spacing={3} sx={{ marginTop: 2 }}>
                  <Grid item xs={12} md={12} lg={12}>
                    <FormControl fullWidth>
                      <TextField
                        label="Technician"
                        name="accomplished-by-technician"
                        value={jobOrder.accomplished_by_technician || ""}
                        disabled={true} // Explicitly ensuring the field is enabled
                      />
                    </FormControl>
                  </Grid>
                </Grid>

              </CardContent>
            </Card>
          </Grid>
          {/* Acknowledged Signature Section */}
          <Grid item xs={12} md={6}>
            <Card variant="outlined"
              sx={{ padding: "20px", marginBottom: "20px", flex: 1 }}
            >
              <CardHeader title={<Typography
                variant="h6"
                sx={{
                  paddingBottom: "1rem",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  fontSize: "1rem",
                }}
              >
                Acknowledged Signature
              </Typography>
              } />
              <CardContent>
                {jobOrder.acknowledgedSignature && (
                  <img
                    src={jobOrder.acknowledgedSignature}
                    alt="Acknowledged Signature"
                    style={{ width: "80%", height: "90px", objectFit: "contain", marginBottom: "10px" }}
                  />
                )}

                <Grid container spacing={3} sx={{ marginTop: 2 }}>
                  <Grid item xs={12} md={12} lg={12}>
                    <TextField
                      fullWidth
                      label="Contact Person"
                      name="Contact Person"
                      variant="outlined"
                      value={
                        jobOrder?.client?.contact
                          ? `${jobOrder?.client?.contact.firstname || ""} ${jobOrder?.client?.contact.lastname || ""
                          }`
                          : ""
                      }
                      disabled
                    />
                  </Grid>
                </Grid>

              </CardContent>
            </Card>
          </Grid>


        </Grid>

        <Grid item xs={12}>
          <Card
            variant="outlined"
            sx={{ padding: "20px", marginBottom: "20px", flex: 1 }}
          >
            <CardHeader
              title={
                <Typography
                  variant="h6"
                  sx={{
                    paddingBottom: "1rem",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: "1rem",
                  }}
                >
                  Document Links
                </Typography>
              }
            />
            <CardContent sx={{ flex: 1 }}>
              <Grid container spacing={3}>
                {jobOrder?.receipts_url ||
                  jobOrder?.receipt_termite_url ||
                  jobOrder?.certificate_url ||
                  jobOrder?.reports_url ? (
                  <>
                    {jobOrder?.receipts_url && (
                      <Grid item xs={12}>
                        <Box>
                          <Link
                            href={jobOrder.receipts_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              textDecoration: "none",
                              color: "primary.main",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            Receipts.pdf{" "}
                            <OpenInNewIcon
                              sx={{
                                marginLeft: 1,
                                fontSize: "1rem",
                              }}
                            />
                          </Link>
                        </Box>
                      </Grid>
                    )}

                    {jobOrder?.receipt_termite_url && (
                      <Grid item xs={12}>
                        <Box>
                          <Link
                            href={jobOrder.receipt_termite_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              textDecoration: "none",
                              color: "primary.main",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            Receipt_Termite.pdf
                            <OpenInNewIcon
                              sx={{
                                marginLeft: 1,
                                fontSize: "1rem",
                              }}
                            />
                          </Link>
                        </Box>
                      </Grid>
                    )}

                    {jobOrder?.certificate_url && (
                      <Grid item xs={12}>
                        <Box>
                          <Link
                            href={jobOrder.certificate_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              textDecoration: "none",
                              color: "primary.main",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            Certificate.pdf
                            <OpenInNewIcon
                              sx={{
                                marginLeft: 1,
                                fontSize: "1rem",
                              }}
                            />
                          </Link>
                        </Box>
                      </Grid>
                    )}

                    {jobOrder?.reports_url && (
                      <Grid item xs={12}>
                        <Box>
                          <Link
                            href={jobOrder.reports_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              textDecoration: "none",
                              color: "primary.main",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            Reports.pdf
                            <OpenInNewIcon
                              sx={{
                                marginLeft: 1,
                                fontSize: "1rem",
                              }}
                            />
                          </Link>
                        </Box>
                      </Grid>
                    )}
                  </>
                ) : (
                  <Grid item xs={12}>
                    <Typography variant="body1" color="textSecondary">
                      No document links available.
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          mt={2}
          mb={2}
        >
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => {
              if (returnTo) {
                // Use window.location.href to force a full page navigation
                window.location.href = returnTo;
              } else {
                navigate("/manage-service-reports");
              }
            }}
            sx={{
              fontSize: "0.875rem",
              color: "#FF4C4C",
              borderColor: "#FF4C4C",
            }}
            disabled={isLoading}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    </BaseFormWrapper>
  );
}

export default ViewServiceReport;
